import React, { useEffect, useState } from 'react';
import UploadSignatureFile from './UploadSignatureFile';
import moment from "moment";
import SignaturePadComponent from './SignaturePadComponent';

const DigitalSignatureComponent = ({ signaturePadRef, fileInputRef, formik, readOnly, readOnlyData, setIsSig, ipAddress, setIpAddress, cDate, setCDate, isCancel, is_Signature, setIs_Signature, signature_Type, isSig, studentSubmissionDetails, disabled}) => {

  const [signatureType, setSignatureType] = useState(0);
  const [fetchDateNIp, setFetchDateNIp] = useState(false);

  useEffect(() => {
    if (fetchDateNIp && !readOnly) {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          if (!is_Signature) {
            setIpAddress(data.ip);
            formik.setFieldValue('signature_ip', data.ip)
          } else {
            setIpAddress(readOnlyData?.signature_ip)
            formik.setFieldValue('signature_ip', readOnlyData?.signature_ip)
          }
        })
        .catch(error => {
          console.error('Error fetching IP address:', error);
        });
      if (!is_Signature) {
        setCDate(moment(new Date().getTime()).format('DD MMM YYYY, HH:mm'))
        formik.setFieldValue('signature_date', moment(new Date().getTime()).format('DD MMM YYYY, HH:mm'))
      } else {
        setCDate(readOnlyData?.signature_date ? readOnlyData?.signature_date : null)
        formik.setFieldValue('signature_date', readOnlyData?.signature_date)
      }
    } else if (!readOnly) {
      setIpAddress('')
      setCDate('')
    }
  }, [fetchDateNIp, is_Signature])

  useEffect(() => {
    if (readOnly) {
      setSignatureType(1)
    }
  }, [readOnly])

  const handleUpload = () => {
    formik.setFieldValue("signature_type", 1)
    setSignatureType(1)
  }

  const handleDraw = () => {
    formik.setFieldValue("signature_type", 0)
    setSignatureType(0)
  }


  useEffect(() => {
    if (signature_Type) {
      setSignatureType(signature_Type)
    }
  }, [signature_Type])

  return (
    readOnly && !readOnlyData?.signature ? null :
      <div className='mb-3'>
        <div className="mt-3 mb-1" title="Signature">Signature{formik?.values?.is_marker_signature_required == 1 ? "*" : ""}</div>
        <div className={`${readOnly ? 'd-none' : 'd-flex'} gap-2 mb-1 py-1`}>
          <div className="border-b-black mr-3" style={{ borderBottom: signatureType == 0 ? '1px #467FCF solid' : '0', color: signatureType == 0 ? '#467FCF' : fetchDateNIp || readOnly ? 'gray' : 'black', cursor: readOnly ? "" : fetchDateNIp ? "not-allowed" : 'pointer' }} onClick={() => { !fetchDateNIp && !readOnly && handleDraw() }} title="Draw">
            <i className="fal fa-signature"></i>
            <span className="ml-1">Draw</span>
          </div>
          <div className="border-b-black" style={{ borderBottom: signatureType == 1 ? '1px #467FCF solid' : '0', color: signatureType == 1 ? '#467FCF' : fetchDateNIp || readOnly ? 'gray' : 'black', cursor: readOnly ? "" : fetchDateNIp ? "not-allowed" : 'pointer' }} onClick={() => { !fetchDateNIp && !readOnly && handleUpload() }} title="Upload Image">
            <i className="fal fa-image"></i>
            <span className="ml-1">Upload Image </span>
          </div>
        </div>
        {signatureType == 0 && (
          <>
            <SignaturePadComponent disabled={disabled} setIsSig={setIsSig} isCancel={isCancel} readOnly={readOnly} setShowIp={setFetchDateNIp} formik={formik} showIp={fetchDateNIp} signaturePadRef={signaturePadRef} readOnlyData={readOnlyData} is_Signature={is_Signature} setIs_Signature={setIs_Signature} setIpAddress={setIpAddress} setCDate={setCDate} studentSubmissionDetails={studentSubmissionDetails} />
          </>
        )}
        {signatureType == 1 &&
          <UploadSignatureFile disabled={disabled} setIsSig={setIsSig} isCancel={isCancel} readOnly={readOnly} readOnlyData={readOnlyData} setShowIp={setFetchDateNIp} formik={formik} showIp={fetchDateNIp} fileInputRef={fileInputRef} is_Signature={is_Signature} setIs_Signature={setIs_Signature} setIpAddress={setIpAddress} setCDate={setCDate} studentSubmissionDetails={studentSubmissionDetails} />
        }
        <div className='mt-2'>
          <span title={`IP: ${readOnly ? readOnlyData?.signature_ip : ipAddress}`}><i className='fal fa-info-circle mr-1'></i><b>IP:</b> {readOnly ? readOnlyData?.signature_ip : ipAddress}</span>
          <span className='ml-2' title={`Date: ${(readOnly && readOnlyData?.signature_date && readOnlyData?.signature_date != null) ? readOnlyData?.signature_date : cDate !== null ? cDate : null}`}><b>Date: </b>{(readOnly && readOnlyData?.signature_date && readOnlyData?.signature_date != null) ? readOnlyData?.signature_date : cDate !== null ? cDate : null}</span>
        </div>
        {/* {formik?.touched?.lecturer_Signature && formik?.errors?.lecturer_Signature ? (
          <div className="invalid-feedback d-block">
            {formik.errors.lecturer_Signature}
          </div>
        ) : null} */}
      </div>
  );
}
export default DigitalSignatureComponent;